import { Theme } from "@mui/material";
import { LIGHT_GREY } from "styles/oneOffColor";

const styles = {
  root: {
    background: "#fff",
    borderRadius: "0.5rem",
    color: "rgba(0, 0, 0, 0.8)",
    fontSize: "0.9rem",
    overflow: "hidden",
    padding: "0.2rem",
    position: "relative",
  },
  item: {
    background: "transparent",
    border: "1px solid transparent",
    borderRadius: "0.4rem",
    display: "block",
    margin: 0,
    padding: "0.2rem 0.4rem",
    textAlign: "left",
    width: "100%",
  },
  isSelected: {
    borderColor: "#000",
  },
  mergeTagContainer: (theme: Theme) => ({
    display: "flex",
    flexDirection: "row",
    backgroundColor: LIGHT_GREY,
    pl: 2,
    pb: 1,
    pt: 1,
    alignItems: "center",
    fontSize: { xs: "11px", sm: "14px" },
  }),
  mergeTag: (theme: Theme) => ({
    borderRadius: 4,
    boxDecorationBreak: "clone",
    padding: "0.2rem 0.5rem",
    backgroundColor: "purple.light",
    color: "purple.dark",
    ml: 1,
    cursor: "pointer",
    border: `1px solid`,
    borderColor: "purple.dark",
  }),
};

export default styles;
